<template>
    <div class="nomination-tab-container">
        <v-tabs
            v-model="selectedTab"
            background-color="transparent"
            class="promo-tabs"
            active-class="promo-tabs__tab--active"
            hide-slider
        >
            <template v-for="tab in tabs" :key="`${tab.label}`">
                <!-- Used to fill and style the space between tabs. -->
                <div class="promo-tabs__spacer" />
                <v-tab :value="tab.value" class="promo-tabs__tab">
                    {{ toSentenceCase(tab.label) }}
                </v-tab>
            </template>
        </v-tabs>
        <v-tabs-window v-model="selectedTab">
            <v-tabs-window-item
                v-for="tab in tabs"
                :key="tab.value"
                :value="tab.value"
                :transition="false"
                :reverse-transition="false"
            >
                <nomination-matrix v-bind="tab.props" />
            </v-tabs-window-item>
        </v-tabs-window>
    </div>
</template>

<script>
import vuexComponentMixin from '@/js/mixins/vuex-component';

const localizationKey = 'planning.nominations';

export default {
    mixins: [vuexComponentMixin],

    props: {
        parentContextType: String,
        storeGroups: Object,
        resources: Object,
        defaultStoreGroups: Object,
        defaultResources: Object,
        onResourceChange: Function,
        onStoreGroupChange: Function,
        createMode: Boolean,
    },

    data() {
        return {
            selectedTab: 0, // Set the first tab to be the default.
            rerender: 0, // Used to rerender a tab
        };
    },

    computed: {
        tabs() {
            return [
                {
                    label: this.$t(`${localizationKey}.provisionHeading`),
                    value: '0',
                    component: 'nomination-matrix',
                    props: this.$props,
                },
                {
                    label: this.$t(`${localizationKey}.defaultHeading`),
                    value: '1',
                    component: 'nomination-matrix',
                    rerender: true,
                    props: {
                        ...this.$props,
                        storeGroups: this.defaultStoreGroups,
                        resources: this.defaultResources,
                        onResourceChange: () => {}, // avoid both matrixes affecting workflow
                        onStoreGroupChange: () => {},
                        createMode: false, // no nomination-templates for defaults
                        showExcludedStores: true,
                        showDetailedProvisions: false,
                        isDefaultMatrix: true,
                    },
                },
            ];
        },
    },
    methods: {
        onTabSwitch(tabNumber) {
            // Rerender defaults tab when we switch back to it.
            // It is needed to make sure default's tab is always up to date with staging area,
            // as changes affecting it can also occur on provision tab
            if (tabNumber === 1) this.rerender += 1;
        },
    },
};
</script>

<style lang="scss" scoped>
.nomination-tab-container {
    width: 100%;
}
.nomination-tab {
    margin: 1.3rem 0;
}
.promo-tabs {
    height: 2.5rem;
    margin-bottom: 1rem;
    border-bottom: 0.1rem solid #eee;
}
</style>
